import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useResizeDetector } from 'react-resize-detector';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    marginRight: theme.spacing(3),
    flexDirection: 'column',
    boxShadow: 'none',
    paddingBottom: theme.spacing(1)
  },
  header: {
    display: 'flex',
    padding: theme.spacing(1.5),
    width: '100%'
  },
  headerLeft: {
    display: 'flex',
    width: '50%'
  },
  headerRight: {
    display: 'flex',
    width: '50%',
    justifyContent: 'flex-end'
  },
  hourAnotation: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  minHour: {
    marginRight: theme.spacing(1)
  },
  maxHours: {
    marginLeft: theme.spacing(1)
  },
  gradient: {
    width: theme.spacing(10),
    height: theme.spacing(1),
    backgroundImage:
      'linear-gradient(to right, #fff , rgba(38, 210, 147, 1) 100%)'
  },
  overTime: {
    display: 'flex',
    marginLeft: theme.spacing(5),
    flexDirection: 'row'
  },
  overTimeIcon: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    border: '4px solid transparent',
    borderTopColor: 'rgba(133, 109, 219, 1)',
    borderRightColor: 'rgba(133, 109, 219, 1)',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.63)
  },
  content: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(1),
    paddign: theme.spacing(1)
  }
}));

const MyTeamHoursLegend: React.FC = () => {
  const classes = useStyles();
  const { ref: chartRef } = useResizeDetector();
  return (
    <Paper
      className={classes.container}
      data-testid={'my-team-hours-legend-container'}
      ref={chartRef}
    >
      <Box
        className={classes.header}
        data-testid={'my-team-hours-legend-header'}
      >
        <div className={classes.headerLeft}></div>
        <div className={classes.headerRight}>
          <div
            className={classes.hourAnotation}
            data-testid={'my-team-hours-legend-hoursAnnotaion'}
          >
            <Typography variant="caption" className={classes.minHour}>
              <FormattedMessage id={'insights.myTeamHoursLegend.minHour'} />
            </Typography>
            <div className={classes.gradient} />
            <Typography variant="caption" className={classes.maxHours}>
              <FormattedMessage id={'insights.myTeamHoursLegend.maxHours'} />
            </Typography>
          </div>
          <div className={classes.overTime}>
            <div
              className={classes.overTimeIcon}
              data-testid={'my-team-hours-legend-overtimeIcon'}
            />
            <Typography variant="caption">
              <FormattedMessage id={'insights.myTeamHoursLegend.overTime'} />
            </Typography>
          </div>
        </div>
      </Box>
    </Paper>
  );
};
export default React.memo(MyTeamHoursLegend);
